import { useGMAutocomplete } from "./useGMAutocomplete"
import { useOSMAutocomplete } from "./useOSMAutocomplete"

export const useMapAutocomplete = useGMAutocomplete
